import http from '../../../plugins/axios';

export default {
  queryWithdrawAddr(url) {
    return http.get({ url });
  },
  querySweepAddr(url) {
    return http.get({ url });
  },
  queryFeeAddr(url) {
    return http.get({ url });
  },
  executeE({ url, data }) {
    return http.post({
      url: url,
      data,
      dataType: 'form'
    });
  }
};
